import React, { useCallback, useRef } from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Sticky from '../../Sticky';
import { scrollIntoViewWithHeader } from '../../utils/scrollIntoViewWithHeader';
import FolderDropdownDesktopMenu from '../FolderDropdownDesktop/FolderDropdownDesktopMenu';
import LoadingIndicator from '../../LoadingIndicator';
import { PopperDropdownManager, PopperDropdownToggle, PopperDropdownContent, } from '../../Dropdown/PopperDropdownLayout';
import cssVars from '@wix/da-ds/src/styles/variables.scss';
import folderDropdownMobileStyles from './FolderDropdownMobile.scss';
var FolderDropdownContent = function (_a) {
    var id = _a.id, isOpen = _a.isOpen, _b = _a.offsetTop, offsetTop = _b === void 0 ? 0 : _b, openDropdown = _a.openDropdown, closeDropdown = _a.closeDropdown, folders = _a.folders, folderNamePostfixIcon = _a.folderNamePostfixIcon, filterEmpty = _a.filterEmpty, disabled = _a.disabled, currentFolder = _a.currentFolder, setSelectedFolderId = _a.setSelectedFolderId, _c = _a.arrowIconSize, arrowIconSize = _c === void 0 ? IconSize.SMALL : _c, showCurrentFolderTotal = _a.showCurrentFolderTotal, isLoading = _a.isLoading, hasMore = _a.hasMore, fetchMore = _a.fetchMore;
    var rootRef = useRef(null);
    var headerHeight = parseInt(cssVars['site-header-height-mobile']);
    var selectFolder = useCallback(function (folderId) {
        setSelectedFolderId(folderId);
        closeDropdown();
        if (rootRef.current) {
            scrollIntoViewWithHeader(rootRef.current, true, offsetTop);
        }
    }, [closeDropdown, setSelectedFolderId, offsetTop]);
    var toggleDropdown = useCallback(function () {
        // If opening a menu, scroll to root element
        if (!isOpen) {
            openDropdown();
            if (rootRef.current) {
                scrollIntoViewWithHeader(rootRef.current, true, offsetTop);
            }
        }
        else {
            closeDropdown();
        }
    }, [isOpen, openDropdown, closeDropdown, offsetTop]);
    var profile_mobile_heading = useFlag('profile_mobile_heading');
    return (React.createElement("div", { className: classnames(folderDropdownMobileStyles['root'], disabled && folderDropdownMobileStyles['disabled'], profile_mobile_heading &&
            folderDropdownMobileStyles['profile_mobile_heading']), ref: rootRef },
        React.createElement(PopperDropdownManager, null,
            React.createElement(Sticky, { className: 'sticky', marginTop: offsetTop + headerHeight }, function (isStuck) { return (React.createElement(PopperDropdownToggle, null,
                React.createElement("div", { className: classnames(folderDropdownMobileStyles['toggle'], isStuck && folderDropdownMobileStyles['stuck']), "aria-hidden": "true", onClick: toggleDropdown },
                    React.createElement("div", { className: classnames(folderDropdownMobileStyles['title'], folderNamePostfixIcon &&
                            folderDropdownMobileStyles['title-with-icon']) },
                        currentFolder && currentFolder.name,
                        showCurrentFolderTotal && currentFolder && (React.createElement("span", { className: folderDropdownMobileStyles['folder-total'] }, currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.totalItemCount)),
                        folderNamePostfixIcon),
                    React.createElement(ArrowDownIcon, { className: classnames(folderDropdownMobileStyles['icon-arrow'], isOpen && folderDropdownMobileStyles['is-open']), size: arrowIconSize })))); }),
            isOpen && (React.createElement("div", { className: folderDropdownMobileStyles['content'] },
                React.createElement(PopperDropdownContent, null,
                    React.createElement(FolderDropdownDesktopMenu, { id: id, folders: folders, filterEmpty: filterEmpty, setSelectedFolderId: selectFolder, currentFolder: currentFolder, hasMore: hasMore, fetchMore: fetchMore }),
                    isLoading && React.createElement(LoadingIndicator, { coverMode: true, view: "llama" })))))));
};
FolderDropdownContent.displayName = 'FolderDropdownContent';
export default FolderDropdownContent;
//# sourceMappingURL=FolderDropdownContent.js.map